import { useContext } from 'react';

import { FwModuleContext } from './FwModuleContext';

const useFwModule = () => useContext(FwModuleContext);

export { useFwModule };
